<template>
  <div class="lotti-terms-privacy-container">
    <h1>Lotti - Nutzungsbedingungen (Terms of Service)</h1>
    <p>
      Diese Nutzungsbedingungen regeln die Nutzung für Lotti, entwickelt und betrieben von Atticode GmbH. Durch die Nutzung der Lotti-App erklären Sie sich mit diesen Nutzungsbedingungen einverstanden. Bitte lesen Sie diese sorgfältig durch.
    </p>

    <h2>1. Einführung</h2>
    <p>
      Diese Nutzungsbedingungen gelten für alle Benutzer der Lotti-App (nachfolgend „App“ genannt). Durch den Zugriff auf und die Nutzung der App erklären Sie sich mit diesen Bedingungen einverstanden.
    </p>

    <h2>2. Registrierung und Benutzerkonto</h2>
    <p>
      <b>Registrierung:</b> Um die App nutzen zu können, müssen Sie ein Benutzerkonto erstellen. Sie verpflichten sich, genaue und vollständige Informationen anzugeben und diese bei Bedarf zu aktualisieren.
    </p>
    <p>
      <b>Sicherheit des Kontos:</b> Sie sind für die Sicherheit Ihres Kontos und Ihres Passworts verantwortlich. Atticode übernimmt keine Haftung für Verluste oder Schäden, die aus der unbefugten Nutzung Ihres Kontos entstehen.
    </p>

    <h2>3. Nutzung der App</h2>
    <p>
      <b>Lizenz:</b> Atticode gewährt Ihnen eine begrenzte, nicht exklusive, nicht übertragbare Lizenz zur Nutzung der App gemäss diesen Bedingungen.
    </p>
    <p>
      <b>Einschränkungen:</b> Sie dürfen die App nicht missbrauchen, indem Sie sie für illegale Aktivitäten nutzen oder versuchen, die App zu modifizieren, zurückzuentwickeln oder zu hacken.
    </p>
    <p>
      <b>Verfügbarkeit:</b> Atticode behält sich das Recht vor, die App oder Teile davon jederzeit zu ändern, auszusetzen oder einzustellen.
    </p>

    <h2>4. Benutzerinhalte</h2>
    <p>
      <b>Verantwortung:</b> Sie sind für alle Inhalte, die Sie über die App übermitteln, verantwortlich. Atticode übernimmt keine Haftung für solche Inhalte.
    </p>
    <p>
      <b>Rechte:</b> Durch das Übermitteln von Inhalten gewähren Sie Atticode das Recht, diese Inhalte zum Zweck des Betriebs der App zu verwenden.
    </p>

    <h2>5. Datenschutz</h2>
    <p>
      <b>Datenschutzrichtlinie:</b> Ihre Nutzung der App unterliegt der Datenschutzrichtlinie von Atticode, die beschreibt, wie wir Ihre persönlichen Daten sammeln, verwenden und schützen (siehe
      <router-link :to="{ name: 'privacy' }">
        Datenschutzbestimmungen
      </router-link>)
    </p>

    <h2>6. Haftungsausschlüsse und Haftungsbeschränkungen</h2>
    <p>
      <b>Keine Garantie:</b> Die App wird "wie besehen" und "wie verfügbar" bereitgestellt. Atticode gibt keine Garantien hinsichtlich der Verfügbarkeit, Genauigkeit oder Zuverlässigkeit der App.
    </p>
    <p>
      <b>Haftungsbeschränkung:</b> Atticode haftet nicht für indirekte, zufällige, spezielle oder Folgeschäden, die sich aus der Nutzung oder der Unmöglichkeit der Nutzung der App ergeben.
    </p>

    <h2>7. Änderungen der Nutzungsbedingungen</h2>
    <p>
      Atticode behält sich das Recht vor, diese Bedingungen jederzeit zu ändern. Änderungen werden durch Veröffentlichung der neuen Bedingungen in der App bekannt gegeben. Ihre fortgesetzte Nutzung der App nach solchen Änderungen gilt als Zustimmung zu den neuen Bedingungen.
    </p>

    <h2>8. Beendigung</h2>
    <p>
      <b>Beendigung durch den Benutzer:</b> Sie können die Nutzung der App jederzeit einstellen und den Support von Atticode zur Löschung Ihrer Daten beauftragen.
    </p>
    <p>
      <b>Beendigung durch Atticode:</b> Atticode behält sich das Recht vor, Ihr Konto und den Zugang zur App jederzeit und ohne vorherige Ankündigung zu beenden, insbesondere bei Verstössen gegen diese Bedingungen.
    </p>

    <h2>9. Anwendbares Recht</h2>
    <p>
      Diese Bedingungen unterliegen den Gesetzen der Schweiz. Streitigkeiten im Zusammenhang mit diesen Bedingungen werden ausschliesslich vor den zuständigen Gerichten in Basel, Schweiz, verhandelt.
    </p>

    <h2>10. Kontakt</h2>
    <p>
      Wenn Sie Fragen oder Bedenken zu diesen Nutzungsbedingungen haben, können Sie Atticode über die folgenden Kanäle kontaktieren:
      <br><br>
      Atticode GmbH<br>
      Concordiastrasse 9<br>
      CH-4142 Münchenstein<br>
      <a href="https://atticode.com">www.atticode.com</a>
    </p>

    <p>
      Atticode GmbH - 1. März 2021
    </p>
  </div>
</template>

<script>
import {router} from '../../main.js';

export default {
  data() {
    return {
     
    }
  },
  methods: {

  },
  mounted() {

  }
}

</script>